import { PopulationSegmentsTable } from './PopulationSegmentsTab/PopulationSegmentsTable.jsx';
import { TopBar } from '../../clientAdminUsers/components/shared/TopBar.jsx';
import { ButtonGroup } from './StyledComponents';
import CreateSegmentButton from './PopulationSegmentsTab/CreateSegment.jsx';
import DownloadCsv from './PopulationSegmentsTab/DownloadCsv.jsx';

const PopulationSegments = () => {
  return (
    <>
      <TopBar>
        <ButtonGroup>
          <DownloadCsv />
          <CreateSegmentButton />
        </ButtonGroup>
      </TopBar>
      <section>
        <PopulationSegmentsTable />
      </section>
    </>
  );
};

export default PopulationSegments;
